import { ChangeDetectionStrategy, Component, inject, TemplateRef, viewChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { PRODUCTS_PER_PAGE } from '@core';
import { SkeletonTemplateService } from '../services/skeleton-template.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'lib-skeleton-loader-templates',
  templateUrl: './skeleton-loader-templates.component.html',
  styleUrl: './skeleton-loader-templates.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxSkeletonLoaderModule, NgTemplateOutlet],
})
export class SkeletonLoaderTemplatesComponent {
  readonly productListItems = Array.from({ length: PRODUCTS_PER_PAGE });
  // One slider page on desktop; narrower screens clip the extra cards.
  readonly productCardsItems = Array.from({ length: 4 });
  readonly skeletonConfig = {
    height: '100%',
    'border-radius': '8px',
    border: '1px solid white',
  };

  private circleTemplate = viewChild.required<TemplateRef<void>>('circleSkeleton');
  private rectangleTemplate = viewChild.required<TemplateRef<void>>('rectangleSkeleton');
  private productListTemplate = viewChild.required<TemplateRef<void>>('productListSkeleton');
  private productCardsTemplate = viewChild.required<TemplateRef<void>>('productCardsSkeleton');

  private skeletonService = inject(SkeletonTemplateService);

  constructor() {
    setTimeout(() => {
      this.skeletonService.setCircleTemplate(this.circleTemplate());
      this.skeletonService.setRectangleTemplate(this.rectangleTemplate());
      this.skeletonService.setProductListTemplate(this.productListTemplate());
      this.skeletonService.setProductCardsTemplate(this.productCardsTemplate());
    });
  }
}
